import type { InputProps } from './inputWrapper/InputWrapper'

type Props = InputProps & { id?: string }

export const createInternalWrapperPropsAndId = ({
  wrapperProps,
  id = crypto.randomUUID(),
}: Props) => ({ internalWrapperProps: { ...wrapperProps, htmlFor: id }, id })
